import { redirect } from "react-router-dom";

import BaseRoute from "../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ReportsDetailRoute extends BaseRoute {
  @service("repositories/tabular-report-repository") tabularReportRepository;

  path = ":id";
  element = (<Template />);
  title = "Report Details";
  revalidateOnParams = ["id"];

  async loader({ params, request }) {
    const reportId = params.id;
    let reportData = null;
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());

    try {
      reportData = await this.tabularReportRepository.findRecord(reportId, searchParams);
    } catch (error) {
      redirect("/reports/list");
    }

    return {
      reportData,
    };
  }
}
